import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { REDUX_SLICE_KEYS } from 'common/constants';
import { formattedDate } from 'utils/dateUtils';
import type { PaymentDateState, PaymentDateCommonType } from './types';
import type { RootState } from 'store';

const currentDate = formattedDate(DateTime.now().toISODate());

const initialState: PaymentDateState = {
  printChecks: {
    paymentDate: currentDate,
    isValid: true
  },
  authorizePayment: {
    paymentDate: currentDate
  }
};

export const paymentDateSlice = createSlice({
  name: REDUX_SLICE_KEYS.paymentDate,
  initialState,
  reducers: {
    setPaymentDate: (
      state: PaymentDateState,
      action: PayloadAction<PaymentDateCommonType>
    ) => {
      if (action.payload.selectedTab === 'printChecks') {
        state.printChecks.paymentDate = action.payload.paymentDate;
      } else state.authorizePayment.paymentDate = action.payload.paymentDate;
    },
    setIsValidPaymentDate: (
      state: PaymentDateState,
      action: PayloadAction<boolean>
    ) => {
      state.printChecks.isValid = action.payload;
    }
  }
});

export const { setPaymentDate, setIsValidPaymentDate } =
  paymentDateSlice.actions;

const selectSelf = (state: RootState) => state;

export const getPaymentDateData = createSelector(
  selectSelf,
  ({ paymentDate }) => paymentDate
);

export const getPaymentDateByPrintChecks = createSelector(
  getPaymentDateData,
  ({ printChecks }) => printChecks.paymentDate
);

export const getPaymentDateByAuthorizePayment = createSelector(
  getPaymentDateData,
  ({ authorizePayment }) => authorizePayment.paymentDate
);

export const getIsValidPaymentDate = createSelector(
  getPaymentDateData,
  ({ printChecks }) => printChecks.isValid
);

export default paymentDateSlice.reducer;
